import { Component, OnInit, ViewChild, ElementRef, Renderer } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { trigger, state, animate, transition, style } from '@angular/animations';

import Utils from '../shared/utility';
import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { ClientService } from '../create-client/client.service';
import { AdvisorBarService } from '../shared/advisor-bar/advisor-bar.service';
import { ModalComponent } from '../shared/modal/modal.component';
import { LoadingService } from '../shared/loading/loading.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';



import { PagerService } from '../services/pager.service';

@Component({
  selector: 'app-new-illustrations',
  templateUrl: './new-illustrations.component.html',
  styleUrls: ['./new-illustrations.component.css']
})
export class NewIllustrationsComponent implements OnInit {

  public tempHCData: any;
  public error: string;
  public partnerActive: boolean = false;
  public client: any;
  clientSpouseFullName;
  
public clients: any[];
public filteredClients: any[];
public selectedClient: any = {};
public reports: any[] = [];
public modalSubscription;
public loadingSubscription;
public previousUrl: string;
public pager: any = {};
public pagedItems: any[];

showHealthcareQuestionnaire: boolean = true;
showLongTermCareQuestionnaire: boolean = true;
showSocialSecQuestionnaire: boolean = true;
showMeansTestingQuestionnaire: boolean = true;
isSSEligible: boolean = true;
isSpouseSSEligible: boolean = true;

  private navCards = [
    { title: 'Healthcare', showQuestionnaire: this.showHealthcareQuestionnaire, subtitle: 'Create a new Healthcare Illustration.', description: '', icon: 'fa-ambulance', color: '#5c7fc1', iconColor: '#3385C5', image:'../../../assets/icons/healthcare_illustration.svg', isCreateReport: true},    
    { title: 'Long-Term Care', showQuestionnaire: this.showLongTermCareQuestionnaire,  subtitle: 'Create a new Long-Term Care Illustration.', description: '', icon: 'fa-user-md', color: '#487879', iconColor: '#fe4e4e', image:'../../../assets/icons/long_term_care_illustration.svg', isCreateReport: true },
    { title: 'Combination', showQuestionnaire: (this.showLongTermCareQuestionnaire && this.showHealthcareQuestionnaire),  subtitle: 'Create a new illustration that combines Healthcare and Long-Term Care.', description: '', icon: 'fa-user-md', color: '#32478a', iconColor: '#fe4e4e', image:'../../../assets/icons/combination_illustration.svg', isCreateReport: true },
    { title: 'Medicare Means Testing', showQuestionnaire: this.showMeansTestingQuestionnaire, subtitle: 'Create a new Medicare Means Testing Illustration.', 
    //description: '<small><b>Note: Only Available as Quick PDF Illustration</b></small>', 
    description: '',
    icon: 'fa-dollar', color: '#63a49e', iconColor: '#2CBFBB', image:'../../../assets/icons/mmt_illustration_white.svg', isCreateReport: true },
    { title: 'Social Security', showQuestionnaire: this.showSocialSecQuestionnaire,  subtitle: 'Create a new Social Security Illustration.', description: '', icon: 'fa-university', color: '#7c59c3', iconColor: '#9578E3', image:'../../../assets/icons/ss_illustration_white.svg', isCreateReport: true }
]

  constructor(private clientService: ClientService, private dialog: MatDialog, private advisorBarService: AdvisorBarService, private globalService: GlobalService, private modalService: ModalService,  
    private pagerService: PagerService, private router: Router, private snackBarService: SnackBarService, private loadingService: LoadingService, private route: ActivatedRoute) {
    
      this.globalService.featMeansTesting = JSON.parse(localStorage.getItem('featMeansTesting'));
      this.globalService.featLongTermCare = JSON.parse(localStorage.getItem('featLongTermCare'));
      this.globalService.featSocialSecurity = JSON.parse(localStorage.getItem('featSocialSecurity'));
      this.globalService.featHealthCare = JSON.parse(localStorage.getItem('featHealthCare'));
      this.globalService.featCombinedHealthcareLTC = JSON.parse(localStorage.getItem('featCombinedHealthcareLTC'));
      
      if(!this.globalService.featHealthCare){
        this.navCards = this.navCards.filter(data => data.title != 'Healthcare');
      }
      if(!this.globalService.featLongTermCare){
        this.navCards = this.navCards.filter(data => data.title != 'Long-Term Care');
      }
      if(!this.globalService.featSocialSecurity){
        this.navCards = this.navCards.filter(data => data.title != 'Social Security');
      }
      if(!this.globalService.featMeansTesting){
        this.navCards = this.navCards.filter(data => data.title != 'Medicare Means Testing');
      }
      if(!this.globalService.featCombinedHealthcareLTC){
        this.navCards = this.navCards.filter(data => data.title != 'Combination');
      }
    
      this.getClients();
      localStorage.setItem('isCreateClient', "False");
      this.modalSubscription = modalService.modal$.subscribe((modal) => {
        if (modal.modalName == 'add-edit-clientClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
          this.getClient(localStorage.getItem('selectedClient'));
        }
      });
  }

  public isOA: boolean;
  public isS: boolean;
  public isA: boolean;
  public isHVS: boolean;
  

  ngOnDestroy() {
    this.modalSubscription.unsubscribe();
  }

  public role: Number;

  ngOnInit() {
    this.role = Number(localStorage.getItem('roleId'));
    this.isOA = (Number(localStorage.getItem('orgID')) === 2 || Number(localStorage.getItem('parentID')) === 2) ? true : false;
    this.isS = (Number(localStorage.getItem('orgID')) === 371 || Number(localStorage.getItem('parentID')) === 371) ? true : false;
    this.isA = (Number(localStorage.getItem('orgID')) === 421 || Number(localStorage.getItem('parentID')) === 421) ? true : false;
    this.isHVS = Number(localStorage.getItem('orgID')) === 1 ? true : false;

    if (localStorage.getItem('selectedClient')) {
      this.getClient(Number(localStorage.getItem('selectedClient')));
      this.getClientReports(Number(localStorage.getItem('selectedClient')));
    }
  }

  getClients() {
    if (window.location.search.split('?')[1] != 'd=t')
      this.loadingService.isLoading(true);

    var spouses;

    this.globalService.getClientsData()
      .subscribe(
      clients => {
        //TODO: figure out if the client/spouse have filled out the necessary questionnaires for each section
        this.clients = clients.map((item) => {
          if (item.c) {
            spouses = JSON.parse(item.cp.Spouses) || [];

            spouses.map((spouse) => {
              if (spouse.maritalStatus == 'Married') {
                item.c.spouseName = spouse.firstName + " " + spouse.lastName;
              }
            });

            return item.c;
          } else {
            return item;
          }
        });

        if (window.location.search.split('?')[1] != 'd=t')
          this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error;
        
        if (window.location.search.split('?')[1] != 'd=t')
          this.loadingService.isLoading(false);
      });
  }

  getClientReports(userID: number) {

    this.globalService.getClientReportsData(userID)
      .subscribe(
      reports => {
        var allReports = [];

        for (var type in reports) {
          reports[type].forEach((report) => {
            allReports.push({
              reportID: report.r.ReportID,
              ID: report.r.ID,
              reportTypeID: report.r.ReportTypeID,
              createdDate: report.r.Created_Date,
              advisorID: report.r.AdvisorID,
            });
          });
        }

        allReports = allReports.sort(function(a, b) {
          return b.ID - a.ID;
        });

        this.reports = allReports;
        this.setPage(allReports.length ? 1 : 0);
      },
      error => this.error = <any>error);
  }

  filterItem(value) {
    this.filteredClients = Object.assign([], this.clients).filter(
      client => ((client.FirstName + " " + client.LastName + " " + client.spouseName).toLowerCase().includes(value.toLowerCase()))
    );
  }

  isClientMarried: boolean = false;
 

  getClient(userID) {
    this.isClientMarried = false;
    this.globalService.getClientData(userID, 4)
      .subscribe(
      client => {
        this.selectedClient = client;

        var spouses = JSON.parse(this.selectedClient.clientProfile.Spouses) || [];
        console.log('spouses', spouses);
        spouses.map((spouse) => {
          if (spouse.maritalStatus == 'Married') {
            this.isClientMarried = true;
            this.selectedClient.client.spouseName = spouse.firstName + " " + spouse.lastName;
            this.selectedClient.client.spouseDOB = spouse.dob;
            this.selectedClient.clientProfile.spouseLifeExpectancy = spouse.LifeExpectancy;
            this.selectedClient.clientProfile.spouseRetirementAge = spouse.retirementAge;
            //this.selectedClient.clientProfile.spouseCurrentIncome  = Utils.formatToCurrency(spouse.currentIncome);
            //this.selectedClient.clientProfile.spousePension = Utils.formatToCurrency(spouse.pension);
            /* if (this.selectedClient.clientProfile.spousePension.includes('$$')) { 
              //if has two, handle; this is an issue with older clients created on the tool
              this.selectedClient.clientProfile.spousePension = spouse.pension;
            } */
            
            this.selectedClient.clientProfile.spouseRetirementState  = spouse.state;
          }
        });
        
        this.clientSpouseFullName = client.clientProfile && spouses[0] && spouses[0].firstName && client.clientProfile.Spouses[0].maritalStatus != 'Widowed' ?
          (client.client.LastName == spouses[0].lastName) ? 
                client.client.FirstName + ' and ' + spouses[0].firstName + ' ' + client.client.LastName :
                client.client.FirstName + ' ' + client.client.LastName + ' and ' + spouses[0].firstName + ' ' + spouses[0].lastName
                : client.client.FirstName + ' ' + client.client.LastName;

        localStorage.setItem('selectedClient', userID.toString())

        if (this.role == 1 || this.role == 2) {
          localStorage.setItem('selectedAdvisor', client.advisor.FirstName + " " + client.advisor.LastName);
          localStorage.setItem('selectedAdvisorID', client.advisor.ID);
          localStorage.setItem('selectedAdvisorOrgID', client.advisor.OrganizationID);
          this.advisorBarService.refresh();
        };
        this.isSSEligible = this.selectedClient.clientProfile.LifeExpectancy < 62 ? false: true;
        this.isSpouseSSEligible = this.isClientMarried ? (this.selectedClient.clientProfile.spouseLifeExpectancy < 62 ? false : true): true;

      },
      error => this.error = <any>error);
  }

  createReport(reportUrl) {
    this.router.navigate(['../reports/create/', reportUrl]);
  }

  selectClient(client, clientSearch) {
    clientSearch.value = client.spouseName ? client.FirstName + " " + client.LastName + " and " + client.spouseName : client.FirstName + " " + client.LastName;
    this.getClient(client.ID);
    this.getClientReports(client.ID);

    this.filteredClients = [];
  }

  handleEditClientModal(e, client) {
    //this.clientService.add('add-edit-client', { ID: Number(localStorage.getItem('selectedClient')) });
    this.router.navigate(['clients/edit']);
  }
  
  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  formatReportTypeID(ReportTypeID: number) {
    return Utils.formatReportTypeID(ReportTypeID);
  }

  
  formatDate(date) {
    date = new Date(date);
    return date > 1/1/1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() + ' ' + Utils.parseDateTime(date) : '--';
  }

  setPage(page: number) {
    if (!this.reports.length) {
      this.pager = [];
      this.pagedItems = [];
      return;
    }

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.reports.length, page);

    // get current page of items
    this.pagedItems = this.reports.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }



}
